// config 들
const env = {
  NODE_ENV: process.env.NODE_ENV || 'development',
  V7_API_URL: process.env.V7_API_URL || '',
  V7_2_API_URL: process.env.V7_2_API_URL || '',
  V6_LAMBDA_URL: process.env.V6_LAMBDA_URL || '',
  V7_COMMON_URL: process.env.V7_COMMON_URL || '',
  ADMIN_API_URL: process.env.ADMIN_API_URL || '',
  GETCHA_API_URL: process.env.GETCHA_API_URL || '',
  AUTO_LOGOUT_TIME: process.env.AUTO_LOGOUT_TIME || 32400,
  SENTRY_DSN: process.env.SENTRY_DSN || '',
  IS_DEV: process.env.IS_DEV === 'Y',
  IS_DEBUG: process.env.IS_DEBUG === 'Y',
  AXIOS_TIMEOUT: +(process.env.AXIOS_TIMEOUT || 10000),
  MEMBER_JOIN_URL: process.env.MEMBER_JOIN_URL || '',
  ADMIN_WEB_URL: process.env.ADMIN_WEB_URL || '',
  PG_CLIENT_KEY: process.env.PG_CLIENT_KEY || '',
  V7_GETCHA_API_URL: process.env.V7_GETCHA_API_URL || '',
  PG_BRAND_PAY_CALLBACK_URL: process.env.PG_BRAND_PAY_CALLBACK_URL || '',
  GETCHA_WEB_URL: process.env.GETCHA_WEB_URL || '',
  PG_TINTING_CLIENT_KEY: process.env.PG_TINTING_CLIENT_KEY || '',
  MALL_API_URL: process.env.MALL_API_URL || '',
};

export default env;
